import { TutorialStep } from "..";

export const TypeInspSteps: TutorialStep[] = [
  {
    // 검사가 라디오 index 0 = 기본 선택이라 사용자가 누를 것이 없다. 안내만 한다.
    target: "#type-insp",
    content: "검사 프로젝트를 만들어보겠습니다.\n검사는 기본으로 선택되어 있어 그대로 진행하면 됩니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#material-name",
    content: "자재명을 자유롭게 입력해보세요.",
    spotlightClicks: true,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#next-btn",
    content: "Next 버튼을 눌러 다음 단계로 이동하세요.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#select-dataset-file",
    content: "기존 선택: 서버에 존재하고 있는 기존 데이터셋 파일을 선택합니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
];
